"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  suggest: {
    approvalCompleted: 'Completed',
    approval: 'Approving',
    selectResponsibleDepartment: 'Please select the responsible department',
    recommendationTracking: 'Opinion /Suggest Tracking',
    managementReviewRecord: 'Management Review',
    noComplete: 'Unfinished ship monitoring',
    reportCannotEmpty: 'The report\' content can not be empty',
    attachmentsCannotEmpty: 'The sign-in sheet can not be empty',
    cannotBeEmpty: 'The responsible department comments can not be empty',
    postBeforeSubmit: 'Please release the document firstly',
    isComplete: 'If completed',
    saveAndSubmit: 'Please saving them before submitting',
    expectedPortReceipt: '预计收货港口',
    tableName: 'Table Name',
    ETA: 'ETA',
    ETD: 'ETD',
    inquiryLogo: '询价标识',
    receivingTime: '接收时间(岸端)',
    transferStatus: '调拨标识',
    transferNo: '调拨单号',
    memo: '申请说明/联系方式',
    download: '下载 Download',
    formNumber: 'Form No.',
    newRecordTable: 'Add Form',
    updateRecordTable: 'Update Form',
    Annexeleased: 'Document(Planed to be released)',
    attachedOriginalProposal: 'Document(Initial)',
    copyAttach: 'Copy Original File',
    newSystemFile: 'Add Document',
    fileInformation: 'Document Info.',
    historicalVersion: 'History Edition',
    updateSystemDocuments: 'Revise Document',
    operationType: 'Operate Type',
    complete: 'Completed',
    applicationInformation: 'Request Info.',
    confirmDelete: 'Are you sure to delete',
    confirmDeleteRecord: 'Are you sure to delete the selected item',
    operationFailure: 'Operate failed.',
    operationSuccessful: 'Operate successfully',
    isCompleteState: 'Are you sure to complete the plan?',
    completed: 'Completed',
    unfinished: 'Processing',
    cancelRelease: 'Cancel Release',
    postFailure: 'Release failed',
    releaseSuccess: 'Release successfully',
    noChange: 'The files can not be edit after released,are you sure to release them?',
    selectRejectNode: 'Please select the node before rejecting',
    actualCompletion: 'Actual completion description',
    networkErrorTryAgain: 'Network error,please retry',
    pleaseSave: 'Please save it first',
    selectApprovalAction: 'Please enter the review comment',
    submittedSuccessfully: 'Submit successfully',
    submissionFailed: 'Submit failed',
    selectPointRejection: 'Please select the node before rejecting',
    changesApplication: 'Request for change',
    tableInvolved: 'Form concerned',
    chaptersInvolved: 'DOC. Section',
    workflow: 'Review History',
    applicationDate: '申领日期 ',
    actionPlanCannotBeEmpty: 'Action plan can not be empty',
    confirmSubmissionRecord: 'Are you sure to submit them',
    addFormFist: 'Please add the risk assessment for the change firstly.',
    selectDate: '请选择预计完成日期',
    common: {
      temporaryStorage: 'Temp. Save',
      saveAndSubmit: 'Save & Submit',
      through: 'Approve',
      reject: 'Reject',
      approved: 'Approved',
      submit: 'Submit'
    },
    vesselOpinion: {
      department: 'Department',
      vesselName: 'Ship',
      fleet: 'Fleet',
      managementCompany: 'DOC',
      reviewTime: 'Review Date',
      captainName: 'Master',
      suggestionsForImprovement: 'Suggestions of Correction & Precaution Measures',
      responsibleDepartment: 'Responsible Department',
      opinionsOfResponsibleDepartment: 'Functional Dep. or Ship\'s comment',
      needToTrack: 'If Tracked',
      expectedCompletionDate: 'Date of schedule',
      actualFinishingDate: 'Date of completion',
      completedBy: 'Operator',
      attachment: 'Attachment',
      reportNo: 'Report No.'
    },
    improveSuggest: {
      copyQuestion: 'Copy Questions',
      title: 'HSQE Implementation',
      item: 'Recommendation for Improvement',
      advice: 'Improvement Plan',
      proposal: 'Ship\'s comment',
      chapterNo: 'DOC. No.',
      record: 'Recommendation for improvement',
      shipStart: 'Start',
      shoreStart: 'Suggested by shore based',
      shoreApprove: 'Reviewed by shore based',
      reviseDocument: 'Revised document by SQA',
      reviseApprove: 'Review after revised ',
      baseInfo: 'General Info.',
      publish: 'Released by SQA',
      updateFile: 'Revise Document',
      updateFileaOrDraft: 'Revise Document/Form draft',
      upLoadFile: 'Upload File',
      approveHistory: 'Review History',
      issueDocument: 'Document(Planned to be released) ',
      handlingOpinions: 'Comment',
      query: {
        status: 'Status',
        vesselCode: 'Ship',
        date: 'Date',
        itemName: 'Item Name'
      },
      table: {
        workNum: 'Job No.',
        suggestPerson: 'Suggested By',
        suggestOrg: 'Suggested By Dept./Ship',
        suggestDate: 'Suggested Date',
        suggest: 'Recommendation for improvement',
        attachmentsName: 'File List',
        validFlag: 'Status',
        detail: 'Details '
      },
      form: {
        department: 'Authority',
        sysOrgId: 'Department',
        workNum: 'Job No.',
        suggestData: 'Suggested Date',
        suggestFileChapterNo: 'DOC. No.',
        suggestFileName: 'DOC. Name',
        recordFormNo: 'Form No.',
        recordFormName: 'Form Name',
        suggester: 'Suggested by',
        suggest: 'Recommendation for improvement',
        qualityFileNo: 'DOC. No.',
        qualityFileName: 'DOC. Name',
        contextFile: 'DOC. Body ',
        commonOpinions: 'General Option',
        auditMind: 'Approve Comment',
        appendix: 'Attachment',
        approveTime: 'Approved Date',
        approver: 'Reviewed by',
        approveFlag: 'Reviewed Status',
        approveOpinions: 'Reviewed Comment',
        approvedDept: 'Reviewed by dept.',
        granter: 'Grantor ',
        attachmented: 'Document(Initial)',
        attachmenting: 'Document(Planned to be released)',
        attachment: 'Attachment'
      },
      message: {
        attach: 'Please upload the Document(Planned to be released)'
      }
    },
    improvePlan: {
      title: 'HSQE Implementation',
      item: 'Improvement Plan',
      query: {
        chapter: 'Doc. No.',
        chapterName: 'Doc. Name',
        date: 'Date'
      },
      table: {
        qualityFileChapter: 'Doc. No.',
        qualityFileChapterName: 'Doc. Name',
        updateContext: 'Revised Content',
        source: 'Reason',
        planDate: 'Planned Date',
        validFlag: 'Status',
        completedBy: 'Operator',
        completedDate: 'Date',
        fileKeyWord: 'KeyWord'
      },
      form: {
        source: 'Source',
        planDate: 'Planned Date for revise ',
        qualityFileChapter: 'Doc. No.',
        qualityFileChapterName: 'Doc. Name',
        updateContext: 'Revised Content'
      }
    },
    moc: {
      title: 'HSQE Implementation',
      item: 'Management of Change',
      applyStart: 'Start Request for Management of Change',
      reportStart: 'Start Request for Management of Change',
      applyStartAudit: 'Approve for Management of Change',
      reportStartAudit: 'Approve for Management of Change',
      upAttachment: 'Upload Attachment',
      changeReport: 'Report for Management of Change',
      query: {
        vesselCode: 'Involving Ships',
        applicant: 'Requested by',
        changeDept: 'Department',
        status: 'Status',
        date: 'Requested Date',
        applicationNo: 'Request No.',
        applicationCategory: 'Type of request',
        degreeEmergency: 'Urgent ',
        degreeEmergencyAn: 'Urgent(Shore based)',
        applyReason: 'Reason for change',
        purpose: 'Purpose'
      },
      table: {
        workNum: 'Job No.',
        applicant: 'Requested by',
        changeDept: 'Requested by Dept.',
        applyDate: 'Requested date',
        changeItem: 'Objective of change',
        changeType: 'Type of change',
        currentSteps: 'Current Step',
        taskResponse: 'Complete description ',
        validFlag: 'Status',
        details: 'Details',
        changeInfoAndDetail: 'Reason for change'
      },
      form: {
        item: {
          baseInfo: 'General Info.',
          changeInfo: 'Reason for change',
          riskAssessment: 'Risk assessment for the change',
          activePlan: 'Action Plan',
          processInfo: 'Review History '
        },
        attachment: {
          attachmentType: 'Attachment Type',
          isTransfer: 'Sync(Ship & Shore)',
          attachmentsName: 'Attachment Name',
          upDate: 'Uploaded Date',
          department: 'Uploaded by Dept.',
          upBy: 'Uploaded by'
        },
        yes: 'Y',
        no: 'N',
        changeType: 'Type of change',
        changeItem: 'Objective of change',
        vesselCode: 'Involving Ships',
        Dept: 'Department',
        applicant: 'Requested by',
        applyDate: 'Requested Date',
        applyNo: 'Request No.',
        approveDate: 'Approved Date',
        changeDept: 'Department concerned',
        changeDetail: 'Brief description',
        changeInfoAndDetail: 'Reason for change（attachment required if any）',
        changeInfoAndDetail1: 'Adverse impact if not implement change',
        changeInfoAndDetail2: 'Meeting minutes for MOC (if any)',
        attachmentsInfo: 'Attachment',
        possibleRisk: 'Risk assessment for the change',
        possibility: 'Probabillity',
        riskDegree: 'Impact degree',
        riskLevel: 'Risk level',
        countermeasures: 'Control measures',
        riskAndProblem: 'Risk or problem identified',
        controlAction: 'Control action to be taken',
        responseDept: 'Responsible department',
        responseDeptOpinion: 'Responsible department comment ',
        trackFlag: 'If tracking',
        completedDate: 'Estimate date of completion',
        planCompletedTime: 'Date schedule',
        isUpdateAttachment: 'Any changes required to HSQEMS',
        updateChapter: 'Chapter of HSQEMS',
        additionSource: 'If any additional resources/Manpower required?',
        reSourceDescription: 'Resources/Manpower description',
        isFree: 'If any cost',
        freeDetail: 'Indicate estimated cost of change',
        planExecuteTime: 'Date of implementation',
        estimatedExecutionTime: 'Estimate date of completion',
        otherRequire: 'Other requirement',
        changeImplementation: 'Change implement'
      }
    }
  },
  shoreReview: {
    index: {
      title: 'HSQE Implementation',
      item: 'Company Management Review',
      review: 'Management Review',
      meetingTrack: 'Tracking for manage review',
      baseInfo: 'Essential Info.',
      attendanceMeetings: 'Sign-in sheet for review meeting',
      reportingMaterials: 'Reporting materials',
      reviewReport: 'Report for Management Review',
      updateFileaOrDraft: 'Upload Attachment',
      query: {
        startBy: 'Suggested by ',
        relatedDept: 'Department concerned',
        status: 'Status',
        date: 'Suggested Date'
      },
      table: {
        jobNo: 'Job No.',
        startBy: 'Suggested By',
        startDate: 'Suggested Date',
        relatedDept: 'Department concerned',
        status: 'Status',
        meetingReview: 'Meeting for Review ',
        valid: 'Completion Description',
        meetingTrack: 'Monitor for Resolutions',
        detail: 'Details'
      },
      form: {
        activityName: 'Activity Name',
        jobNo: 'Job No.',
        company: 'Company ',
        examine: 'Examine',
        reviewDate: 'Review Date',
        reviewtimeInterval: 'Review Range Date ',
        meetingType: 'Meeting for Management Review',
        ProposedDate: 'Suggested Date',
        attachmentType: 'Attachment Type',
        status: 'Sync(Ship & Shore) ',
        attachmentName: 'Attachment Name',
        uploadDate: 'Uploaded Date',
        uploadDept: 'Uploaded by Dept.',
        uploadPerson: 'Uploaded by',
        oprate: 'Operation'
      }
    }
  },
  shipReview: {
    index: {
      baseInfo: 'BaseInfo',
      implementation: 'Implementation',
      attachment: 'attachment',
      completeDescription: 'Complete Description',
      advice: 'Corrective and Preventative actions or Improving suggestions',
      analysisCause: 'Cause Analysis',
      problems: 'Unexpected problems found',
      reviewContext: 'Items of Review',
      actualCompletionDate: 'Actual CompletionDate',
      plannedCompletionDate: 'Planned CompletionDate',
      implementationStatus: 'Implementation Status',
      title: 'HSQE Implementation',
      item: 'SMS Master Review',
      time: 'Review date must be the next date of the end date in the recent SMS review  ',
      uncompletedSMSMonitor: 'Monitor for Un-completed SMS Review',
      reviewRecord: 'SMS Review List',
      remind: 'Warning',
      managementReview: 'SMS Review',
      approve: 'Reviewed by SQA',
      departmentApprove: 'Reviewed by Function Dept.',
      summary: 'Summary by SQA',
      captainReceive: 'Master Received',
      query: {
        vesselType: 'Ship Type',
        serviceLength: 'Office Term',
        lastServiceLength: 'Review time after last',
        vesselCode: 'Ship',
        status: 'Status',
        date: 'Suggested Date'
      },
      table: {
        jobNo: 'Job No.',
        startBy: 'Suggested By',
        reviewTime: 'Review Range Date',
        startDate: 'Suggested Date',
        relatedShip: 'Ship',
        reviewDate: 'Review Date',
        rectificationItem: 'Corrective',
        valid: 'Status',
        details: 'Details',
        completion: 'Completion',
        problems: 'Unexpected problems found',
        completionDate: 'Planned completion date',
        finishedCondition: 'finished Condition'
      },
      form: {
        item: {
          baseInfo: 'General Info.',
          changeInfo: 'Reason for Change',
          riskAssessment: 'Risk assessment for the change',
          activePlan: 'Action Plan',
          processInfo: 'Review History'
        },
        attachment: {
          uploadAttachment: 'Upload Attachment',
          attachmentType: 'Attachment Type',
          isTransfer: 'Sync(Ship & Shore)',
          attachmentsName: 'Attachment Name',
          upDate: 'Uploaded Date',
          department: 'Uploaded by Dept.',
          upBy: 'Uploaded by'
        },
        dateRules: 'The completion date cannot be empty',
        yes: 'Y',
        no: 'N',
        activeName: 'Activity Name',
        jobNo: 'Job No.',
        relatedShip: 'Ship\'s Name',
        reviewDate: 'Review  Date ',
        reviewtimeInterval: 'Review Range Date',
        captainName: 'Master',
        embarkationDate: 'Date Of Appointment',
        others: 'Sign-in sheet & Other attachment',
        reviewReport: 'Report of Master\'s SMS Review',
        reviewContext: 'Items of Review',
        outstandProblem: 'Deficiencies found',
        analysisCause: 'Cause Analysis',
        advice: 'Corrective and Preventative actions or Improving suggestions',
        operationAndMonitor: 'HSQE Implementation and monitoring, including the internal/external documents, circulars, certificates and records, etc. up to date, study and management.',
        voyageExecution: 'Voyage implementation, including cargo transportation and navigation safety',
        shipMaintenance: 'Maintenance',
        crewManagement: 'Crew management, including the crew competence, obedience and training, etc.',
        riskIdentityAndManager: 'Risk identification and management',
        shipAccident: 'Accident/Incident /Near miss/Violation occurred',
        boardingInspection: 'Company boarding inspection External/Internal Audit',
        inspection: 'PSC/ External inspection',
        SSPExecution: 'Implementation on SSP',
        MLCExecution: 'Implementation on MLC',
        informationReflected: 'Monthly safety meeting report ',
        other: 'Others',
        generalEvaluation: 'Overall evaluation'
      }
    },
    uncompleted: {
      allVessel: 'All Ships',
      mineVessel: 'My Ship',
      vesselName: 'VesselName',
      captain: 'Captain',
      lengthOfService: 'Length Of Service',
      embarkationDate: 'Date Of Appointment',
      days: 'days',
      all: 'all',
      lastReviewDate: 'Last Review Date',
      lastReviewDay: 'Since Last Review'
    },
    confirm: {
      tip: 'Tip',
      msgTip: 'You have been in the current ship for less than 90 days. Are you sure to initiate management review',
      confirm: 'Confirm',
      cancel: 'Cancel',
      cancelReview: 'The SMS Master Review has been canceled'
    }
  },
  moc: {
    public: {
      selectMsg: 'Please select '
    }
  },
  recordBusinessJob: {
    postId: 'Position',
    ship: 'Ship',
    title: 'Record and Search',
    keyword: 'Record Number/Name',
    businessActivities: 'Business Activities',
    recordNo: 'Record No.',
    recordName: 'Record Name',
    version: 'Version',
    revisionNo: 'Revision No.',
    effectiveDate: 'Effective Date',
    storageLocation: 'Storage Location',
    shelfLife: 'Shelf Life',
    formType: 'Form Type',
    inSystemForms: 'Record Form Within The System',
    outSystemForms: 'Non System Record Form'
  },
  recordJobManage: {
    lastJobDate: 'Last Filling Date',
    fillingContents: 'Filling Contents',
    baseInfo: 'BaseInfo',
    jobNo: 'Job No.',
    draft: 'Draft',
    processing: 'Processing',
    completed: 'Completed',
    vessel: 'Vessel',
    breadcrumbTitle: 'Job List',
    workDialogTitle: 'Record Business Job',
    workNo: 'Job No.',
    initWork: 'Initiating Work',
    businessActivities: 'Business Activity',
    sponsorDept: 'Initiator\'s Department',
    relatedForms: 'Involving Forms',
    status: 'Status',
    startDate: 'Launch Date',
    sponsor: 'Sponsor',
    sponsorPost: 'Promoter Post',
    vesselCode: 'Involving Ships',
    voyageNo: 'Voyage No.',
    jobDescription: 'Job Description',
    otherAttach: 'Other Attachments',
    rules: {
      cannotEmpty: 'can not be empty',
      attach: 'Please upload the attachment first'
    }
  },
  monitorPeriodRecordJob: {
    record: 'Record',
    job: 'Work Monitor',
    monitorJob: 'Monitor Period Record Job',
    vessel: 'Vessel',
    startByDept: 'Start By Dept.',
    normal: 'Normal',
    windowPeriod: 'Window Period',
    overdue: 'Overdue',
    startByVessel: 'Start By Vessel',
    startByPost: 'Start By Post.',
    reportingCycle: 'Reporting Cycle',
    plannedFillingDate: 'Planned Filling Date',
    fillingDate: 'Filling Date',
    status: 'Status',
    recordJobMonitor: {
      keyword: 'No. / Name',
      no: 'Order No.',
      num: 'No.',
      name: 'Name',
      version: 'Version'
    }
  }
};